/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Next_2Inputs */

const en_contact_next_2 = /** @type {(inputs: Contact_Next_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You get a reply within one working day.`)
};

const lv_contact_next_2 = /** @type {(inputs: Contact_Next_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildi saņemat vienas darba dienas laikā.`)
};

/**
* | output |
* | --- |
* | "You get a reply within one working day." |
*
* @param {Contact_Next_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_next_2 = /** @type {((inputs?: Contact_Next_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Next_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_next_2(inputs)
	return en_contact_next_2(inputs)
});